import { render, staticRenderFns } from "./braze-notification-card.vue?vue&type=template&id=6d4c0fbc&"
import script from "./braze-notification-card.vue?vue&type=script&lang=js&"
export * from "./braze-notification-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports